var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"creditsOutstandingPage"}},[_c('CreditsOutstandingTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }